export default __webpack_public_path__ + "static/media/reprove.89de2797.svg";